var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ReviewPreview"},[(_vm.hasReview)?_c('ReviewExternal',{attrs:{"reviewExternal":_vm.reviewExternal}}):_vm._e(),_c('DiffLaptops',{attrs:{"incoming":_vm.reviewExternal.laptop,"original":_vm.laptop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }